import { logoutUser } from "@/services/user";
import React from "react";
import Countdown, { CountdownRenderProps } from "react-countdown";
import { useTranslation } from "react-i18next";
import Button from "../Buttons/Button";
import Modal from "./index";

interface LogoutWarningModalProps {
  isOpen: boolean;
  onLogoutNow?: () => void;
  countdownSeconds?: number;
  message: string;
  waitDuration?: number;
  okHandler: () => void;
}

const LogoutWarningModal: React.FC<LogoutWarningModalProps> = ({
  isOpen,
  countdownSeconds = 30,
  message,
  okHandler,
}) => {
  const { t } = useTranslation();

  const renderer = ({ minutes, seconds }: CountdownRenderProps) => {
    return (
      <span>
        {minutes}m:{seconds}s
      </span>
    );
  };

  const onCompleteHandler = () => {
    logoutUser();
  };

  if (!isOpen) return null;

  return (
    <Modal
      isOpen={isOpen}
      widthSize="md:w-[480px]"
      contentClassName="logout-warning-modal !z-[999999999]"
      onCancel={() => {}}
      containerClassName="!z-[9999999]"
    >
      <div className="flex flex-col rounded-[24px] overflow-hidden">
        <div className="z-[99] border-b-[1px] border-[#E2E2E2] flex justify-center py-[16px] px-[24px] bg-white">
          <h3 className="text-[18px] font-semibold font-outfit">
            {t("logout_warning_modal.title")}
          </h3>
        </div>

        <div className="bg-[#F9F9F9] p-[24px] text-center">
          <p className="text-[16px] text-black mb-2 leading-[1.5]">
            {message}{" "}
            <Countdown
              date={Date.now() + countdownSeconds * 1000}
              renderer={renderer}
              onComplete={onCompleteHandler}
            />
          </p>
        </div>
        <div className="border-t-[1px] flex items-center  gap-[15px] border-[#E2E2E2]  px-[24px] py-[16px] bg-white ">
          <Button
            size="small"
            variant="secondary"
            iconVisibility="hide"
            ariaLabel="Logout now"
            label={t("logout_warning_modal.logout_now")}
            handleClick={logoutUser}
          />

          <Button
            size="small"
            variant="primary"
            iconVisibility="hide"
            ariaLabel="Stay Connected"
            label={t("logout_warning_modal.stay_connected")}
            handleClick={okHandler}
          />
        </div>
      </div>
    </Modal>
  );
};

export default LogoutWarningModal;
